import { CompanyDockageEntity, EMPTY_COMPANY_DOCKAGE_ENTITY } from "domain/entity/Company/CompanyDockageEntity";
import { CompanyDockageRepository } from "domain/repository/Company/CompanyDockageRepo";
import _ from "lodash";
import { DockTierDroOpts } from "presentation/constant/DropDownOptions/Company/DockTierDroOpts";
import { CompanyDetailModel } from "presentation/model/Company/CompanyDetailModel";

import BaseViewModel from "presentation/viewModel/BaseViewModel";
import { Dispatch, SetStateAction } from "react";
import { IFieldValue } from "veronica-ui-component/dist/component/core";

interface CompanyDockageVMProps extends BaseViewModel {
    dispatch: [
        Dispatch<SetStateAction<CompanyDetailModel>> | ((value: SetStateAction<CompanyDetailModel>) => void),
    ]
    companyDockageRepo: CompanyDockageRepository
}

export const CompanyDockageVM = ({ dispatch, companyDockageRepo }: CompanyDockageVMProps) => {
    const [companyDetailDispatch] = dispatch;
    const onFieldChange = (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }

        return companyDetailDispatch(prevState => {
            return {
                ...prevState,
                companyDockageState: {
                    ...prevState.companyDockageState,
                    currentCompDockage: {
                        ...prevState.companyDockageState.currentCompDockage,
                        [fieldKey]: val
                    }
                },
                viewState: {
                    ...prevState.viewState,
                    allFormState: {
                        ...prevState.viewState.allFormState,
                        [fieldKey]: "",
                    }
                }
            }
        });
    }
    const onSave = async (currentCompEntity: CompanyDockageEntity) => {
        return await companyDockageRepo.addCompDockage(currentCompEntity).then((data) => {
            if (data && data.toString().startsWith("Error:")) {
                companyDetailDispatch(prevState => {
                    return {
                        ...prevState,
                        allFormState: { "saveCompDockageFailed": data.toString() }
                    };
                });
                return { "saveCompDockageFailed": data.toString() };
            } else {
                return companyDetailDispatch(prevState => {
                    return {
                        ...prevState,
                        isShowRightPanel: false,
                        viewState: {
                            ...prevState.viewState,
                            isAdd: false,
                            isRead: true,
                            isEditable: false,
                            isSaveClicked: false,
                            lastEditRowId: '',
                            isSliderOpen: false,
                            allFormState: {},

                            isShowFsp: false,
                            isShowEmptyPool: false,
                            isShowSuppleTerms: false,
                            isShowCustAssign: false,
                            isShowFactor: false,
                            isShowCustInfo: false,
                            isShowDockage: false
                        },
                        companyDockageState: {
                            ...prevState.companyDockageState,
                            currentCompDockage: { ...EMPTY_COMPANY_DOCKAGE_ENTITY },
                            editCompDockage: { ...EMPTY_COMPANY_DOCKAGE_ENTITY }
                        }
                    }
                })

            }
        }).catch((error) => {
        });
    }
    const onDelete = async (selectedRows: CompanyDockageEntity[]) => {
        await companyDockageRepo.deleteCompDockage(
            selectedRows.map(selectedRow => selectedRow.id) as number[]
        ).then((res) => {
            companyDetailDispatch(prevState => {
                return {
                    ...prevState,
                    isShowRightPanel: false,
                    viewState: {
                        ...prevState.viewState,
                        isShowDeleteModal: false,
                        dataType: ""
                    },
                    companyDockageState: {
                        ...prevState.companyDockageState,
                        selectedDatas: [],
                        currentCompDockage: { ...EMPTY_COMPANY_DOCKAGE_ENTITY },
                        editCompDockage: { ...EMPTY_COMPANY_DOCKAGE_ENTITY }
                    }
                }
            });
        })
    }
    const onCheckboxChange = (checked: boolean, fieldName: string) => {
        companyDetailDispatch(prevState => {
            return {
                ...prevState,
                companyDockageState: {
                    ...prevState.companyDockageState,
                    currentCompDockage: {
                        ...prevState.companyDockageState.currentCompDockage,
                        [fieldName]: checked ? "Y" : "N",
                    }
                }
            }
        })
    }

    const loadDropdownOption = async () => {
        companyDetailDispatch(prevState => {
            return {
                ...prevState,
                dynamicOptions: {
                    ...prevState.dynamicOptions,
                    tierDropdownOptions: DockTierDroOpts().getTierByItemList()
                }
            }
        });
    }

    const onInitDefaultValue = () => {
        companyDetailDispatch(prevState => {
            const compDockage = prevState.companyDockageState.currentCompDockage;
            return {
                ...prevState,
                companyDockageState: {
                    ...prevState.companyDockageState,
                    currentCompDockage: {
                        ...compDockage,
                        tier: compDockage.id === 0 ? Number(DockTierDroOpts().getTierByItemList()[0].value) : compDockage.tier,
                        calculatedByHours: compDockage.id === 0 ? "Y" : compDockage.calculatedByHours,
                    }
                }
            }
        });
    }

    const onAdd = () => {
        companyDetailDispatch(prevState => {
            return {
                ...prevState,
                isShowRightPanel: true,
                viewState: {
                    ...prevState.viewState,
                    isAdd: true,
                    isEditable: false,
                    isSaveClicked: false,
                    isShowFsp: false,
                    isShowEmptyPool: false,
                    isShowSuppleTerms: false,
                    isShowCustAssign: false,
                    isShowFactor: false,
                    isShowCustInfo: false,
                    isShowDockage: true,
                    allFormState: {}
                },
                companyDockageState: {
                    ...prevState.companyDockageState,
                    selectedDatas: [],
                    currentCompDockage: { ...EMPTY_COMPANY_DOCKAGE_ENTITY },
                    editCompDockage: { ...EMPTY_COMPANY_DOCKAGE_ENTITY }
                }
            }
        });
    }

    const onEdit = (currentCompEmptyPool: CompanyDockageEntity) => {
        companyDetailDispatch(prevState => {
            return {
                ...prevState,
                isShowRightPanel: true,
                viewState: {
                    ...prevState.viewState,
                    isAdd: false,
                    isEditable: prevState.viewState.isEditCompDtlInfo,
                    isSaveClicked: false,
                    isShowFsp: false,
                    isShowEmptyPool: true,
                    isShowSuppleTerms: false,
                    isShowCustAssign: false,
                    isShowFactor: false,
                    isShowCustInfo: false,
                    allFormState: {}
                },


            }
        });
    }

    const handleDelete = () => {
        companyDetailDispatch(prevState => {
            return {
                ...prevState,
                isShowRightPanel: false,

                viewState: {
                    ...prevState.viewState,
                    isShowDeleteModal: true,
                    dataType: "DOCKAGE"
                }
            }
        });
    }


    const onDockageRowDoubleClick = (row: CompanyDockageEntity) => {
        companyDetailDispatch(prevState => {
            return {
                ...prevState,
                isShowRightPanel: true,
                viewState: {
                    ...prevState.viewState,
                    //isAdd: false,
                    isEditable: prevState.viewState.isEditCompDtlInfo,
                    isSaveClicked: false,
                    isShowFsp: false,
                    isShowEmptyPool: false,
                    isShowSuppleTerms: false,
                    isShowCustAssign: false,
                    isShowFactor: false,
                    isShowCustInfo: false,
                    isShowDockage: true,
                    allFormState: {}
                },
                companyDockageState: {
                    ...prevState.companyDockageState,
                    currentCompDockage: row,
                    editCompDockage: row,

                }
            }
        })
    }
    const onSelectedCompEmptyPools = (selectedRows: CompanyDockageEntity[]) => {
        // const isSingleSelRow = selectedRows && selectedRows.length === 1 ? true : false;

        companyDetailDispatch(prevState => {
            return {
                ...prevState,
                companyDockageState: {
                    ...prevState.companyDockageState,
                    selectedDatas: selectedRows,
                }
            }
        });
    }



    const initialDockageTableData = async (compnayId: number) => {
        await companyDockageRepo.searchCompDockage(compnayId).then(data => {
            companyDetailDispatch(prevState => {
                return {
                    ...prevState,
                    companyDockage: data,
                    companyDockageState: {
                        ...prevState.companyDockageState,
                        forceRefresh: !prevState.companyDockageState.forceRefresh,
                    }
                }
            })
        })
    }


    return {
        onAdd: onAdd,
        onEdit: onEdit,
        onSave: onSave,
        onDelete: onDelete,
        onSelectedCompEmptyPools: onSelectedCompEmptyPools,
        onFieldChange: onFieldChange,
        onCheckboxChange: onCheckboxChange,
        loadDropdownOption: loadDropdownOption,
        onInitDefaultValue: onInitDefaultValue,
        handleDelete: handleDelete,
        onDockageRowDoubleClick: onDockageRowDoubleClick,
        initialDockageTableData: initialDockageTableData
    }
}